<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" *ngIf="val && !modify">
  <div fxLayout="column" [fxFlex]="'100'" fxFlex.lt-md="100" fxLayoutGap="15px">
<a></a>
<div fxLayout="row" [fxFlex]="'100'" fxFlex.lt-md="100%"  fxLayoutGap="15px">
     <div fxFlex="100">
       <mat-card>
         <div style="display: flex; justify-content: space-between; align-items: center;">
           <h3>Dane</h3>
           <div fxLayoutGap="15px">
           <button [disabled]="!(userPermissions | async).meeting.write" (click)="edit()" mat-stroked-button color="warn"><mat-icon>edit</mat-icon> <span> Edytuj</span></button>
           <button [disabled]="!((userPermissions | async).meeting.delete && meetingObject.createdBy.uuid === userProfile.userId) && !(userPermissions | async).meeting.admin_root "  (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
           <button *ngIf="meetingObject?.filename" mat-stroked-button color="accent" aria-label="Pobierz agendę" (click)="downloadFile(meetingObject.uuid)" class="flout">
             <mat-icon>download</mat-icon> Pobierz Agendę
           </button>
           </div>
         </div>
         <div fxLayout="row" fxLayoutGap="15px">
           <app-detail *ngIf="meetingObject?.type" [fxFlex]="meetingObject?.leader ? '50' : '100'" header="Rodzaj" [value]="meetingObject.type.name"></app-detail>

           <app-detail *ngIf="meetingObject?.leader" [fxFlex]="meetingObject.leader.id === 229 ? '25' : '50'" header="Organizator" [value]="meetingObject.leader.name"></app-detail>
           <app-detail *ngIf= "meetingObject?.iddTrainingTrainer" fxFlex="25" header="Prowadzący szkolenie" [value]="meetingObject.iddTrainingTrainer.firstName + ' ' + meetingObject.iddTrainingTrainer.lastName"></app-detail>
         </div>

         <div fxLayout="row" fxLayoutGap="15px" *ngIf="meetingObject?.meetingLeading">
           <app-detail fxFlex="100" header="Prowadzący szkolenie" [value]="meetingObject.meetingLeading"></app-detail>
         </div>


         <div fxLayout="row" *ngIf="meetingObject?.insuranceCompany">
           <app-detail fxFlex="100" header="TU" [value]="meetingObject.insuranceCompany.name"></app-detail>

         </div>

         <div fxLayout="row" *ngIf="meetingObject?.subject">
           <app-detail fxFlex="100" header="Temat" [value]="meetingObject.subject"></app-detail>
         </div>

         <div fxLayout="row" fxLayoutGap="15px" *ngIf="meetingObject?.type.key === MEETING_TYPE_IDD_TRAINING "  >
           <app-detail fxFlex="50" header="Liczba minut - majątek" [value]="meetingObject.minutesAssets?.toString()"></app-detail>
           <app-detail fxFlex="50" header="Liczba minut - życie" [value]="meetingObject.minutesLife?.toString()"></app-detail>
         </div>


         <div fxLayout="row" fxLayoutGap="15px">
           <app-detail fxFlex="50" header="Data rozpoczęcia" [value]="meetingObject?.startsAt | date:'y-MM-dd HH:mm'"></app-detail>

           <app-detail *ngIf="meetingObject?.thematicScope.length <= 0" fxFlex="50" header="Czas trwania" [value]="meetingHours + ' godz. ' + meetingMinutes + ' min.'"></app-detail>
           <app-detail *ngIf="meetingObject?.thematicScope.length > 0" fxFlex="50" header="Czas trwania" [value]="(meetingObject.minutesTotal - (meetingObject.minutesTotal%60) )/ 60 + ' godz. '+meetingObject.minutesTotal%60 + ' min.'"></app-detail>
         </div>

         <div fxLayout="row" fxLayoutGap="15px" >
           <app-detail fxFlex="50" header="Data zakończenia" [value]="meetingObject?.endsAt | date:'y-MM-dd HH:mm'"></app-detail>
           <!--              <div fxFlex="50"></div>-->
              <!--            </div>-->

              <!--            <div fxLayout="row">-->
           <app-detail fxFlex="50" header="Typ" [value]="meetingObject?.place.name"></app-detail>
         </div>

         <div fxLayout="row" *ngIf="meetingObject?.link">
           <app-detail fxFlex="100" header="Link" [value]="meetingObject?.link" [externalLink]="meetingObject.link"></app-detail>
         </div>

         <div fxLayout="row" fxLayoutGap="15px" *ngIf="meetingObject?.type.key === MEETING_TYPE_IDD_TRAINING || meetingObject?.type.key === MEETING_TYPE_NEW_AGENT_TRAINING " >
           <app-detail fxFlex="50" header="Do kiedy można zapisywać" [value]="meetingObject?.registrationsTo | date:'y-MM-dd HH:mm'"></app-detail>

           <div fxFlex="50" fxLayout="row" fxLayoutGap="15px">
             <app-detail fxFlex="50" header="Pozostało miejsc" [value]="meetingObject?.placesLeft?.toString()"></app-detail>

             <app-detail fxFlex="50" header="Limit osób" [value]="meetingObject?.limitOfPeople?.toString()"></app-detail>
           </div>
         </div>
         <div fxLayout="row" fxLayoutGap="15px" *ngIf="meetingObject?.limitOfPeople">
           <app-detail fxFlex="100" header="Limit osób" [value]="meetingObject?.limitOfPeople?.toString()"></app-detail>
         </div>
         <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
           <app-detail  [fxFlex]="100" header="Organizator" [value]="meetingObject?.createdBy.firstName +' '+ meetingObject?.createdBy.lastName"></app-detail>
         </div>
         <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" *ngIf="meetingObject.place.key==='stationary'">
           <app-detail-bool [fxFlex]="50" header="Centrala ASF" [value]="meetingObject?.central"></app-detail-bool>

           <app-detail-bool [fxFlex]="50" header="Loża PGE" [value]="meetingObject?.pge"></app-detail-bool>

           <app-detail *ngIf="meetingObject?.central" [fxFlex]="50" header="Sala" [value]="meetingObject?.room.name"></app-detail>
         </div>
         <div fxLayout="row" fxLayoutGap="15px"  fxLayoutAlign=" center" *ngIf="meetingObject.place.key==='stationary'">
           <app-detail-bool [fxFlex]="50" header="Nocleg" [value]="meetingObject?.accommodation"></app-detail-bool>
           <app-detail-bool [fxFlex]="50" header="Posiłek" [value]="meetingObject?.meal"></app-detail-bool>

         </div>
         <div fxLayout="row" fxLayoutGap="15px"  fxLayoutAlign=" center" *ngIf="meetingObject?.accommodation || meetingObject?.meal" >
           <div fxFlex="50">
             <app-detail *ngIf="meetingObject?.accommodationDetail" [fxFlex]="100" header="Szczegóły" [value]="meetingObject?.accommodationDetail"></app-detail>
           </div>
           <div fxFlex="50">
            <app-detail *ngIf="meetingObject?.mealDetail" [fxFlex]="100" header="Szczegóły" [value]="meetingObject?.mealDetail"></app-detail>
           </div>
         </div>
       </mat-card>
     </div>
   </div>

   <div fxLayout="row" fxLayoutGap="15px" fxFlex.lt-md="100%" *ngIf="meetingObject?.thematicScope.length > 0">
     <div fxFlex="100" fxLayoutGap="15px">
       <mat-expansion-panel >
         <mat-expansion-panel-header>
           <div fxLayout="row" >
             <h3>Zakres tematyczny szkolenia</h3>
           </div>
         </mat-expansion-panel-header>
         <div fxLayout="row" fxLayoutGap="15px">
           <div fxFlex="100">
             <ng-container *ngFor="let thematicScope of meetingObject.thematicScope; let i = index">
               <div fxLayout="row" fxLayoutGap="15px">
                 <app-detail fxFlex="50" header="Data rozpoczęcia" [value]="thematicScope.thematicScopeStartsAt | date:'y-MM-dd ' + thematicScope.thematicScopeStartsAtTime"></app-detail>
                 <app-detail fxFlex="50" header="Czas trwania" [value]="(thematicScope.thematicScopeMinutesTotal - (thematicScope.thematicScopeMinutesTotal%60) )/ 60 + ' godz. '+thematicScope.thematicScopeMinutesTotal%60 + ' min.'"></app-detail>
               </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Data zakończenia" [value]="thematicScope.thematicScopeEndsAt | date:'y-MM-dd ' + thematicScope.thematicScopeEndsAtTime"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="100" header="Temat" [value]="thematicScope.thematicScopeSubject"></app-detail>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>

        </div>
      </div>


    <div fxLayout="row" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px" *ngIf="meetingObject?.address">
      <app-detail-address [fxFlex]="100" header="Adres" [address]="meetingObject.address"></app-detail-address>
    </div>
  </div>
</div>
<div>
  <app-meeting-add *ngIf="modify" [meeting]="meeting" [dialogRefFront]="true"  [statusEdit]="false" (closeModification)="modify = false; close()"></app-meeting-add>
</div>
